// **** import modules ****
// import $ from "jquery";
import app, { vuwer } from "@@assets/scripts/common";

// **** process ****
const dataKey = "slides_menu";

vuwer.add("menuSection", {
	selector: "#menu_section",
	onReadyFirst($self) {
		if(!$self) {
			return false;
		}
		
		const $body = $self.children(".section-body");
		this.setProp({ $body });
	}
}, function() {
	// [add child vuw]
	this
	// define [slider]
	.add("slider", {
		vuwType: "slider",
		module: { app, dataKey },
		
		selector: () => this.$body && this.$body.children(
			".slide-container"
		).eq(0),
		
		async onReady($self) {
			if(!$self) {
				return false;
			}
		}
	});
});
